import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';

const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormItem = Form.Item;

function UpdateForm({ form, item: { word } }) {
  const { getFieldDecorator } = form;
  return (
    <Form>
      <FormItem label="敏感词" {...formItemLayout}>
        {getFieldDecorator('word', {
          rules: [{ required: true, message: '请输入敏感词' }],
          initialValue: word,
        })(<Input />)}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default Form.create()(UpdateForm);
